import { render, staticRenderFns } from "./BreadCrumb.vue?vue&type=template&id=460ea416"
import script from "./BreadCrumb.vue?vue&type=script&lang=js"
export * from "./BreadCrumb.vue?vue&type=script&lang=js"
import style0 from "./BreadCrumb.vue?vue&type=style&index=0&id=460ea416&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports